import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export default function SectionCard({
  icon,
  title,
  subtitle,
  children,
}: SectionCardProps) {
  return (
    <Box
      sx={{
        border: '1px solid #ece1d5',
        borderRadius: '24px',
        background:
          'linear-gradient(180deg, rgba(255,249,242,1) 0%, rgba(255,255,255,1) 100%)',
        p: { xs: '18px', md: '24px' },
        boxShadow: '0 12px 32px rgba(126, 67, 8, 0.06)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '14px',
          mb: '20px',
        }}
      >
        <Box
          sx={{
            width: '44px',
            height: '44px',
            borderRadius: '14px',
            backgroundColor: '#fff1e3',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>

        <Box>
          <Typography
            sx={{
              color: '#281302',
              fontSize: '22px',
              fontWeight: 700,
              lineHeight: '30px',
              mb: '4px',
            }}
          >
            {title}
          </Typography>
          {!!subtitle && (
            <Typography
              sx={{
                color: '#6c5b4c',
                fontSize: '15px',
                lineHeight: '24px',
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {children}
    </Box>
  );
}
